import { AppContextProvider } from '@startupquickstart/frontend';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { initAnalytics } from './lib/analytics';
import './index.css';

initAnalytics();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppContextProvider defaultTheme="light">
      <App />
    </AppContextProvider>
  </StrictMode>,
);
